import React from 'react';
import { useSelector } from 'react-redux';
import Listing from '../../../components/Listing';

const ListingsView = () => {
	const listings = useSelector((state) => state.listings.data);

	return (
		<div>
			<h3 className='page-header'>Manage Listings</h3>
			{
				listings.length === 0
					? 'No listings created yet'
					: listings.map((listing) => <Listing key={listing._id} {...listing} />)}
		</div>
	)
}

export default ListingsView;